module.exports = __webpack_public_path__ + "static/img/59.1cb4f69.gif";


//////////////////
// WEBPACK FOOTER
// ./static/layui/images/face/59.gif
// module id = EteU
// module chunks = 1